import PopUp, { openModal } from "../core/PopUp";
import { IconDots } from "@tabler/icons-react";
import ReportCompact from "./ReportCompact";

function ReportList(id: string) {
  return (
    <li key={id} className="list-row cursor-pointer">
      <PopUp id={`report-setting-${id}`} title={"Report"}>
        Reports sind noch ein beta-feature. Falls die Antwort in dem Textfeld
        auf sich warten lässt, dann wende dich an kontakt@surfanzeigen.de.
      </PopUp>
      <div className="flex gap-4 list-col-grow">
        <ReportCompact id={id} />
      </div>

      <button
        className="btn btn-square "
        onClick={(e) => {
          e.stopPropagation();
          openModal(`report-setting-${id}`);
        }}
      >
        <IconDots />
      </button>
    </li>
  );
}

const ReportsList = ({ reportIds }: { reportIds: string[] }) => {
  return (
    <ul className="list bg-base-200 rounded-box">
      {reportIds.map(ReportList)}
    </ul>
  );
};
export default ReportsList;
